"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostedLanguageModelModelProvider = void 0;
exports.PostedLanguageModelModelProvider = {
    OpenAi: "OPEN_AI",
    CustomLanguageModel: "CUSTOM_LANGUAGE_MODEL",
    Anthropic: "ANTHROPIC",
    Fireworks: "FIREWORKS",
    Groq: "GROQ",
    Google: "GOOGLE",
};
